import { useDialog } from "../hooks/useDialog"
import { RectifyPayment } from "../parts/dialog-views/RectifyPayment"
import { Alert } from "../parts/dialog-views/Alert"
import { Confirm } from "../parts/dialog-views/Confirm"

export const Dialog = () => {

    const dialog = useDialog()

    return (
        <>
         <dialog open={dialog.isOpened} className={`dialog-${dialog.currentView}`}>
        {
            dialog.currentView === 'rectify-payment' ?
            <RectifyPayment data={dialog.data}/>
            :
            dialog.currentView === 'alert' ?
            <Alert data={dialog.data}/>
            :
            dialog.currentView === 'confirm' ?
            <Confirm data={dialog.data}/>
            :
            null
        }
        </dialog>
        <div className={`dialog-blur ${dialog.isOpened ? 'on' : 'off'}`}></div>
        </>
    )
}